import { useAuth } from "react-oidc-context";
import { VendorListTools } from "./VendorListTools";
import { VENDORS, StaticVendor } from "../vendorsData";

import styled from 'styled-components'

export const Wrapper = styled.div`
  display: grid;
  padding-top: 3rem;
  width: 100%;
  max-width: 1240px;

  .vendor-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding: 1rem 2rem 2rem;
  }

  @media (min-width: 700px) {
    .vendor-grid {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (min-width: 1024px) {
    .vendor-grid {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  .btn-vendor-link {
    display: inline-block;
    margin-top: 0.5rem;
    padding: 0.375rem 0.75rem;
    background: var(--hot-pink, #e91e8c);
    color: white;
    font-weight: bold;
    text-align: center;
    border-radius: var(--fine-border-radius, 6px);
    border: 2px solid transparent;
    letter-spacing: var(--letterSpacing);
    text-transform: capitalize;
    transition: border-color 0.25s ease, box-shadow 0.25s ease;
    cursor: pointer;
  }

  .btn-vendor-link:hover {
    border-color: var(--nighttime, #1a1a4e);
    box-shadow: 0 0 0 2px var(--nighttime, #1a1a4e);
  }
`

export const VendorsList = () => {
  const auth = useAuth();

  return (
    <Wrapper>
      <div className='lr-padded-container center-text'>
        <h1 style={{ marginBottom: '25px' }}>Makers Market</h1>
        <hr style={{ maxWidth: '200px', marginInline: 'auto' }} />
      </div>

      {auth.isAuthenticated && <VendorListTools />}

      <div className="vendor-grid">
        {VENDORS.map((vendor: StaticVendor) => (
          <article key={vendor.id} style={{
            display: 'flex', flexDirection: 'column', borderRadius: '12px',
            background: 'white', boxShadow: '0 2px 8px rgba(64,64,64,0.15)', overflow: 'hidden'
          }}>
            {vendor.imageUrl
              ? <img src={vendor.imageUrl} alt={vendor.name} style={{ width: '100%', height: '200px', objectFit: 'cover', display: 'block' }} />
              : <div style={{ width: '100%', height: '200px', background: 'var(--pagebackground, #b0bcd4)' }} />
            }
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, padding: '1.25rem', gap: '0.5rem' }}>
              <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', margin: 0, color: 'var(--nighttime)' }}>{vendor.name}</h3>
              <p style={{ fontSize: '0.92rem', flex: 1, color: '#333' }}>{vendor.description}</p>
              <a href={vendor.website ?? '#'} target="_blank" rel="noopener noreferrer" className="btn-vendor-link">
                Visit Website
              </a>
            </div>
          </article>
        ))}
      </div>
    </Wrapper>
  )
}
